import React, { useState, useEffect } from "react";
import Tickets from "../../AppLib/AppLib_Tickets";
import Utils from "../../utils/utils";
import { FiSend } from "react-icons/fi";
import { useToast } from "../ToastContext";
import Icon from "../../utils/Icons";
const { CATEGORY, PRIORITY, STATUS } = Tickets;

const TicketView = ({ props }) => {
  const { item, setTickets } = props;
  const [tkt, setTck] = useState(JSON.parse(JSON.stringify(item)));
  const showToast = useToast();
  const [user, setUser] = useState({});
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(true);

  const HandleSend = async () => {
    if (input.trim()) {
      const obj = {
        userId: user.userId,
        user: user.userName,
        message: input,
        createdAt: Utils.getCurrentTime(),
      };
      const result = await Tickets.buzzcussion(tkt._id, obj);
      if (result.success) {
        setMessages(result.data.buzz); // Store chat messages
        setInput(""); // Clear input field
      } else {
        showToast(result.error, "error", true, 3000);
      }
    }
  };

  const categories = CATEGORY[tkt.product] || {};
  const status = STATUS[tkt.status];
  const priority = PRIORITY[tkt.priority];

  const HandleMarkResolve = async (e, status) => {
    e.preventDefault();
    const confirm = window.confirm("Are you sure ? ");
    if (!confirm) return;

    const s =
      status == 2
        ? "Reopen the ticket."
        : status == 3
        ? "mark Resolved the ticket."
        : "Completed Process (closed).";

    const obj = {
      type: "step",
      doer: user.userName,
      doerId: user.userId,
      message: s,
      time: Utils.getCurrentTime(),
    };
    const result = await Tickets.markTicketResolve(tkt._id, status, obj);
    if (result.success) {
      const updated = result.data;
      setTck((prev) => updated);
      setTickets((prev) =>
        prev.map((elem) => (elem._id === updated._id ? updated : elem))
      );
      showToast(result.result || "Success", "success", true, 3000);
    } else {
      showToast(result.result || "Something went wrong", "warning", true, 3000);
    }
  };
  const getPreview = (url) => {
    if (url.includes("youtube.com")) {
      const videoId = new URL(url).searchParams.get("v");
      return (
        <iframe
          width="300"
          height="200"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="rounded-lg"
        ></iframe>
      );
    } else if (url.includes("docs.google.com")) {
      return (
        <iframe
          width="300"
          height="200"
          src={url.replace("/edit", "/preview")}
          title="Google Doc Preview"
          frameBorder="0"
          className="rounded-lg"
        ></iframe>
      );
    } else {
      return <p className="text-gray-700">Preview not available</p>;
    }
  };
  useEffect(() => {
    const user = Utils.getLoggedInUser();
    setUser((prev) => user);

    setTimeout(async () => {
      const result = await Tickets.getTicket(tkt._id);
      if (result.success) {
        if (result.data?.buzz) {
          setLoadingMessages(false);
          setMessages(result.data.buzz);
        }
      } else {
        showToast(result.error, "error", true, 3000);
      }
    }, 2000);
  }, []);

  return (
    <div className="min-h-full h-full overflow-x-hidden overflow-y-auto p-4 rounded-lg bg-gray-50">
      <div className="flex xs:flex-col h-full gap-4">
        {/* Left Section - Ticket Details */}
        <div className="w-[30%] flex flex-col h-full xs:h-auto xs:w-full">
          <div className="bg-white shadow-md rounded-lg h-full flex flex-col overflow-hidden">
            <div className="h-16 p-4 bg-gray-100 border-b">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold text-gray-800">
                  Ticket Details
                </h3>
                <span className="font-medium text-gray-600">
                  Tkt-{tkt.ticketNumber}
                </span>
              </div>
            </div>
            <div className="p-4 flex-grow overflow-y-auto space-y-4">
              <h2 className="text-lg font-bold underline cursor-pointer">
                {tkt.title}
              </h2>
              <p className="text-gray-700">{tkt.description}</p>
              <div className="space-y-2">
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 font-medium">Category:</span>
                  <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-lg text-sm">
                    {categories[tkt.category] || "Unknown"}
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 font-medium">Priority:</span>
                  <span
                    className={`${priority.bg} ${priority.text} px-3 py-1 rounded-lg text-sm`}
                  >
                    {priority.name}
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-gray-600 font-medium">Status:</span>
                  <span
                    className={`${status.bg} ${status.text} px-3 py-1 rounded-lg text-sm`}
                  >
                    {status.name}
                  </span>
                </div>
              </div>
              <div className="pt-4 border-t text-sm text-gray-600">
                Created at:{" "}
                <span className="font-medium">
                  {Utils.formatDateTime(tkt.createdAt)}
                </span>
              </div>
              {item.attachments.length > 0 && (
                <div className="bg-gray-100 p-4 shadow-md rounded-lg mt-4">
                  <a
                    href={item.attachments[0]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    Open Attachment
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Section - Activity Log */}
        <div className="flex-1 flex flex-col h-full">
          <div className="bg-white flex justify-between items-center h-16 pl-4 pr-4 border-b rounded-t-lg">
            <h3 className="text-lg font-semibold text-gray-800">
              Activity Log
            </h3>
            <div className="flex gap-2">
              {tkt?.status < 3 && (
                <button
                  onClick={(e) => HandleMarkResolve(e, 3)}
                  className="px-4 py-1 h-7 text-xs border border-green-600 text-green-600 uppercase rounded-md hover:bg-green-50 transition"
                >
                  Mark Resolve
                </button>
              )}
              {tkt?.status >= 3 && (
                <button
                  onClick={(e) => HandleMarkResolve(e, 2)}
                  className="px-4 py-2 m-0 text-sm bg-indigo-100 border tracking-[0.5px]  hover:tracking-[0.05rem] transition-all duration-300 hover:shadow-lg border-indigo-600 text-indigo-600 uppercase rounded-md"
                >
                  Reopen
                </button>
              )}
            </div>
          </div>

          {/* Message Section */}
          <div className="shadow-inner h-full mt-2 border rounded-lg flex-1 flex flex-col overflow-hidden bg-white">
            <div className="p-4 flex-1 overflow-y-auto space-y-3">
              {loadingMessages ? (
                <p className="text-blue-500 italic">Loading updates...</p>
              ) : messages.length > 0 ? (
                messages.map((msg, index) => {
                  const currentDate = Utils.formatDateTime(
                    msg.createdAt,
                    "date",
                    false
                  );
                  const previousDate =
                    index > 0
                      ? Utils.formatDateTime(
                          messages[index - 1].createdAt,
                          "date",
                          false
                        )
                      : null;
                  const isNewDate = currentDate !== previousDate;
                  return (
                    <React.Fragment key={index}>
                      {isNewDate && (
                        <div className="text-center mx-auto w-fit text-xs text-gray-500 font-semibold my-2">
                          <span className="inline-block shadow-md bg-gray-100 px-3 py-1 rounded-md">
                            {currentDate}
                          </span>
                        </div>
                      )}
                      <div
                        className={`flex items-start p-3 shadow-sm rounded-lg w-[90%] ${
                          user.userId === msg.userId
                            ? "ml-auto bg-green-100"
                            : "mr-auto bg-amber-50"
                        }`}
                      >
                        <div className="flex items-center justify-center w-8 h-8 rounded-full text-md font-semibold overflow-hidden bg-gray-200 border">
                          {Utils.getUserAvatar(msg.user)}
                        </div>
                        <div className="ml-3 flex-1 space-y-1">
                          <p className="text-sm font-semibold">{msg.user}</p>
                          <p className="text-sm">{msg.message}</p>
                          <p className="text-xs text-gray-500 italic">
                            {Utils.formatDateTime(msg.createdAt, "time", true)}
                          </p>
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })
              ) : (
                <p className="text-gray-500">No messages yet...</p>
              )}
            </div>

            {/* Message Input */}
            <div className="p-3 flex items-center gap-3 bg-gray-100 rounded-b-lg">
              <textarea
                className="shadow-inner flex-1 min-h-14 max-h-28 h-20 p-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
                rows="2"
                placeholder="Type your message..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
              />
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
                onClick={HandleSend}
              >
                <FiSend />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketView;
